/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Point/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Point({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Transactions/Transaction/Point"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Point.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-5zw4U': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--w-2-5zw4U': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--h-3-5zw4U': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-4-5zw4U': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Point.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-2-5zw4U': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-3-5zw4U': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-4-5zw4U': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}